import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BusComponent } from './components/bus/bus.component';
import { StopsComponent } from './components/stops/stops.component';
import { TimesComponent } from './components/times/times.component';
import { ViewFavoritesComponent } from './components/view-favorites/view-favorites.component';
import { RatesComponent } from './components/rates/rates.component';
import { NoticesComponent } from './components/notices/notices.component';

const routes: Routes = [
  { path: '', component: BusComponent },
  { path: 'stops', component: StopsComponent },
  { path: 'times', component: TimesComponent },
  { path: 'favorites', component: ViewFavoritesComponent },
  { path: 'rates', component: RatesComponent},
  { path: 'notices', component: NoticesComponent},
  {
    path: 'simulate',
    children: [
      { path: '', component: BusComponent },
      { path: 'stops', component: StopsComponent },
      { path: 'times', component: TimesComponent },
      { path: 'favorites', component: ViewFavoritesComponent },
      { path: 'rates', component: RatesComponent},
      { path: 'notices', component: NoticesComponent},
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
